import { useCallback } from "react";

import { nativeApplicationVersion } from "expo-application";
import ExpoConstants from "expo-constants";
import {
  deviceType,
  manufacturer,
  modelName,
  osName,
  osVersion,
} from "expo-device";

import { getDeviceTypeValue, getDeviceUniqueId } from "@/utils/device.util";
import { isWeb } from "@/utils/platform.util";

const UnknownValue = "unknown";

const useDeviceInfo = () => {
  // on native, expo-application reads the version from the native binary
  // on web, expo-constants reads the version from EXPO_PUBLIC_WEB_APP_VERSION/app.config.js
  const appVersion = isWeb()
    ? ExpoConstants.expoConfig?.version || UnknownValue
    : nativeApplicationVersion || UnknownValue;

  const deviceInfo = {
    appVersion,
    manufacturer: manufacturer || UnknownValue,
    modelName: modelName || UnknownValue,
    osName: osName || UnknownValue,
    osVersion,
    type: getDeviceTypeValue(deviceType),
  };

  const getDeviceInfo = useCallback(async () => {
    const deviceId = await getDeviceUniqueId();

    return {
      ...deviceInfo,
      deviceId,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    getDeviceInfo,
  };
};

export default useDeviceInfo;
